<template>
  <div>
    <navbar/>
    <error-panel showInPopup="false" />
    <Spinner :loaded="loaded" />
    <main role="main" v-if="loaded">
        <div class="jumbotron" id="tl-jumbotron">
          <div class="container">
            <div class="row tl-link-block tl-link-block-header pb-1 mb-3">
              <h4 class="col-7">
                <span class="bi bi-cloud-arrow-up-fill text-info mr-2"/>
                <span>My imports</span>
                <div class="pb-1 mb-1">
                  <span class="tl-subtext-header">View and create imports</span>
                </div>
              </h4>

              <span class="col-5 pt-3 mb-1 text-right">
                <a href="/new-import" class="btn btn-success">
                  <span class="d-none d-sm-block">
                    <i class="bi bi-plus-square mr-2"></i>
                    New import...
                  </span>
                  <span class="d-sm-none d-block">
                    <i class="bi bi-plus-square mr-2"></i>
                    New...
                  </span>
                </a>
              </span>


            </div>

            <div data-title="emptyState" v-if="!hasImportJobs" class="row tl-link-block p-4">
              <div class="col-sm-1 d-none d-sm-block">
                <i class="bi bi-list-check tl-emptystate-icon"></i>
              </div>
              <div class="col-sm-9 col-12">
                <div class="tl-link-title">
                  Nothing to see here... yet!
                </div>
                <div class="tl-link-small mt-3">
                  Bring in your existing bookmarks! Click on the "New Import..." button to start.
                </div>
              </div>
            </div>

            <div class="row tl-link-block" v-for="job in importJobs" v-bind:key="job.id">
              <div class="col-sm-8 col-9">
                <h6 class="" style="">import from {{ browserLabel(job.importType) }}</h6>
                <div>
                  <span class="bi bi-calendar3 tl-link-info-icon"></span>
                  <span class="tl-link-small pl-1">{{ getDisplayDates(job) }}</span>
                </div>
                <div>
                  <i :class="statusIconClasses(job.status)"></i><span class="pl-1 tl-link-small">{{ job.status }}</span>
                </div>
              </div>
              <div v-if="job.status==='COMPLETED'" class="col-sm-4 pt-4 col-3 text-right">

                <span class="d-none d-sm-inline">

                  <a :href="'/imports/'+job.id" class="btn btn-primary"><i class="bi bi-eye mr-2"></i>View bookmarks</a>
                </span>
                <span class="d-sm-none d-inline">
                  <a :href="'/imports/'+job.id" class="btn btn-primary">View</a>
                </span>

              </div>
            </div>

          </div>
        </div>
    </main>
    <tlfooter v-if="loaded"/>
  </div>
</template>

<script>
import navbar from "@/components/NavBar";
import tlfooter from "@/components/Footer";
import ErrorPanel from "@/components/ErrorPanel";
import BackendClient from "@/rest/backend-client";
import Spinner from "@/components/Spinner";
import BROWSER_CONFIG from '@/util/browsers.js';

export default {
  name: "ImportStartPage",
  head: {
    title: 'just bookmark it! - my imports'
  },
  components: { ErrorPanel, navbar, tlfooter, Spinner },
  props: [''],
  data() {
    return {
      backendClient: new BackendClient(),
      importJobs: [],
      loaded: false,
      statusIcons: {
        COMPLETED: "bi-check-circle-fill text-success",
        WAITING: "bi-hourglass-split text-info",
        IN_PROGRESS: "bi-hourglass-split text-info",
        FAILED: "bi-exclamation-triangle-fill text-danger",
      }
    };
  },

  mounted() {
    this.backendClient.getImports().then(responseData => {
      this.importJobs = responseData;
      this.loaded = true;
    });
  },

  computed: {
    hasImportJobs() {
      return this.importJobs && this.importJobs.length > 0;
    },

  },

  methods: {
    statusIconClasses(status) {
      return "bi " + (this.statusIcons[status] || 'bi-emoji-astonished')
    },
    formatDate(date) {
      return this.$options.filters.date(date);
    },
    getDisplayDates(job) {
      if (job.completedAt) {
        return 'finished ' + this.formatDate(job.completedAt);
      }

      return 'started ' + this.formatDate(job.registeredAt);
    },
    browserLabel(value) {
      const b = BROWSER_CONFIG.find(b => b.value === value);
      return b ? b.label : value;
    },
  }
};
</script>
<style>

</style>
